import { create } from 'zustand';

/**
 * Research Anchor — a persistent, user-clearable context label that travels
 * across every page of the dashboard.
 *
 * Phase 1: stores a free-text label set by the chat widget.
 * Phase 2 (Option E): will be extended with structured filters
 *   (party, topic, keywords, relevant bill/councillor IDs) so pages can
 *   filter and annotate data based on the active research context.
 */
interface AnchorState {
  isActive: boolean;
  label: string;
  setAnchor: (label: string) => void;
  clearAnchor: () => void;
}

export const useAnchorStore = create<AnchorState>((set) => ({
  isActive: false,
  label: '',

  setAnchor: (label: string) => {
    const trimmed = label.trim();
    if (!trimmed) return;
    set({ isActive: true, label: trimmed });
  },

  clearAnchor: () => set({ isActive: false, label: '' }),
}));
